import _defineProperty from "@babel/runtime/helpers/defineProperty";
import i18n from 'i18next';
import Promise from 'bluebird';
import $ from 'jquery';
import moment from 'moment';

var log = require('loglevel').getLogger('utils/init');

var initialState = JSON.parse(document.getElementById('initial-state').innerHTML || '{}');
var cfg = initialState.envCfg;
export default function (callback) {
  var language = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'zh-TW';
  Promise.resolve($.get("".concat(cfg.contextRoot, "/build/locales/").concat(language, ".json?").concat(moment().valueOf()))).then(function (data) {
    return data;
  }).then(function (resources) {
    i18n.init({
      lng: language,
      fallbackLng: 'zh-TW',
      resources: _defineProperty({}, language, resources)
    }, function (err) {
      log.info("Loaded language files: ".concat(language));

      if (err) {
        log.error(err);
      }

      return callback(i18n);
    });
  });
}